import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFileScanner = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M1.124 10.923a.75.75 0 0 1 .75.75v2.753h2.753a.75.75 0 0 1 0 1.5H1.124a.75.75 0 0 1-.75-.75v-3.503a.75.75 0 0 1 .75-.75M14.875 10.923a.75.75 0 0 1 .75.75v3.503a.75.75 0 0 1-.75.75h-3.503a.75.75 0 0 1 0-1.5h2.753v-2.753a.75.75 0 0 1 .75-.75M5.55 11.44c0 .139.113.25.25.25h4.33a.25.25 0 0 0 .25-.25v-.447h1.5v.447a1.75 1.75 0 0 1-1.75 1.75H5.8a1.75 1.75 0 0 1-1.75-1.75v-.447h1.5z" />
    <path
      fillRule="evenodd"
      d="M8.063 2.817c.454 0 .89.178 1.216.494l2.07 2.002c.34.33.532.784.532 1.257v1.445h2.374v1.5H1.746v-1.5H4.05V4.567c0-.966.783-1.75 1.75-1.75zM5.8 4.317a.25.25 0 0 0-.25.25v3.448h4.83V6.57a.3.3 0 0 0-.009-.062H8.614a.5.5 0 0 1-.5-.5V4.323a.3.3 0 0 0-.052-.006z"
      clipRule="evenodd"
    />
    <path d="M4.627.072a.75.75 0 1 1 0 1.5H1.874v2.753a.75.75 0 1 1-1.5 0V.822a.75.75 0 0 1 .75-.75zM14.875.072a.75.75 0 0 1 .75.75v3.503a.75.75 0 0 1-1.5 0V1.572h-2.753a.75.75 0 0 1 0-1.5z" />
  </svg>
);
export default SvgFileScanner;
